
import React from 'react';
import { DeviceFormData, ValidationErrors } from '../types';
import DeviceProfileStep from '../steps/DeviceProfileStep';
import TransportConfigStep from '../steps/TransportConfigStep';
import AlarmRulesStep from '../steps/AlarmRulesStep';
import DeviceProvisioningStep from '../steps/DeviceProvisioningStep';

interface FormStepContentProps {
  step: number;
  formData: DeviceFormData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  availableProtocols: string[];
  errors: ValidationErrors;
}

const FormStepContent: React.FC<FormStepContentProps> = ({
  step,
  formData,
  handleChange,
  availableProtocols,
  errors
}) => {
  switch (step) {
    case 1:
      return <DeviceProfileStep formData={formData} handleChange={handleChange} />;
    case 2:
      return (
        <TransportConfigStep 
          formData={formData} 
          handleChange={handleChange}
          availableProtocols={availableProtocols}
          errors={errors}
        />
      );
    case 3:
      return <AlarmRulesStep formData={formData} handleChange={handleChange} errors={errors} />;
    case 4:
      return <DeviceProvisioningStep formData={formData} handleChange={handleChange} />;
    default:
      return null;
  }
};

export default FormStepContent;
